import { IMemberOrchestrators } from "@nju/data-access-portal-member";
import { IOfferMode } from "@nju/data-access-portal-offers";
import { useOrchestrators } from "@nju/data-access-portal-orchestrator";
import { PaymentState } from "@nju/data-access-portal-payment";
import { IScope } from "@nju/scope";
import { SidebarFtthPayment } from "./SidebarFtthPayment";
import { SidebarMobilePayment } from "./SidebarMobilePayment";

interface ISidebarPaymentProps {
  mode: IOfferMode;
  variant?: IScope;
  memberOrchestrator?: IMemberOrchestrators;
  isLoading?: boolean;
  paymentState?: PaymentState;
}

export function SidebarPayment({
  mode,
  variant = "portal",
  isLoading,
  paymentState,
  memberOrchestrator,
}: ISidebarPaymentProps) {
  const mobile = useOrchestrators("mobile", { isOptional: true });
  const resolvedOrchestrator =
    variant !== "sales" ? memberOrchestrator?.mobile || mobile : mobile;
  const ftthOrchestrator = useOrchestrators("ftth", { isOptional: true });

  return (
    <>
      {mode === "ftth" && (
        <SidebarFtthPayment
          ftthOrchestrator={ftthOrchestrator}
          isLoading={isLoading}
          isPending={false}
          paymentState={paymentState}
          variant={variant}
        />
      )}
      {mode === "mobile" && (
        <SidebarMobilePayment
          isPending={false}
          orchestrator={resolvedOrchestrator}
          paymentState={paymentState}
          userId={mobile?.userId}
          variant={variant}
        />
      )}
    </>
  );
}
